function handleProductVariantChanged(variant) {
  if(document.querySelector('.klaviyo-bis-trigger')) {
    if(variant.available === true) {
      document.querySelector('.klaviyo-bis-trigger').style.display = 'none';
    } else {
      document.querySelector('.klaviyo-bis-trigger').style.display = 'flex';
    }
  }
}

// Select all elements with the class "product__media-item"
const mediaItems = document.querySelectorAll('.product__media-item[data-media-type=video]');

// Callback function for MutationObserver
const handleMutation = (mutationsList, observer) => {
  mutationsList.forEach(mutation => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const targetElement = mutation.target;
      const videoElement = targetElement.querySelector('video');
      if (!videoElement) {
        return;
      }

      const isHidden = window.getComputedStyle(targetElement).display === 'none';

      if (isHidden) {
        videoElement.pause();
      } else {
        videoElement.play();
      }
    }
  });
};

// Create a new MutationObserver instance
const observer = new MutationObserver(handleMutation);

// Observe each element for changes in attributes
mediaItems.forEach(item => {
  observer.observe(item, {
    attributes: true, // Watch for attribute changes
    attributeFilter: ['class'] // Only watch the 'style' attribute
  });
});
